module.exports = __webpack_public_path__ + "img/GuaB.b28a3118.png";